import { useConsumerSelector, useAppSelector, useCheckoutError } from '..'
import { COUNTRY_FIELDS_HIDDEN } from '../../component/DriversLicence/constants'
import { createSelector } from '@reduxjs/toolkit'
import { CheckoutAppSelector } from '../'
import { IdentityState } from './reducer'

// Selectors
export const identitySelector: CheckoutAppSelector<IdentityState> = (state) => state.identity

export const biometricOptOutSelector: CheckoutAppSelector<boolean | null> = createSelector(identitySelector, (state) => state.biometricOptOut)

export const biometricApplicantIdSelector: CheckoutAppSelector<string | undefined> = createSelector(identitySelector, (state) => state.biometricApplicantId)

export const skipBiometricCheckSelector: CheckoutAppSelector<boolean | undefined> = createSelector(identitySelector, (state) => state.skipBiometricCheck)

// Hooks
export const useIdentitySelector = (): IdentityState => useAppSelector(identitySelector)

export const useBiometricOptOut = (): boolean | null => useAppSelector(biometricOptOutSelector)

export const useBiometricApplicantId = (): string | undefined => useAppSelector(biometricApplicantIdSelector)

export const useSkipBiometricCheck = (): boolean | undefined => useAppSelector(skipBiometricCheckSelector)

export const useCountryStateIsShown = (): boolean => {
  const { accountCountry } = useConsumerSelector()
  if (accountCountry === undefined) {
    return false
  }

  const hiddenFields: readonly string[] = COUNTRY_FIELDS_HIDDEN[accountCountry as keyof typeof COUNTRY_FIELDS_HIDDEN] ?? []
  return !hiddenFields.includes('state')
}

export const useIsConsumerEligibleForCreditFacilityIntroduction = (): boolean => {
  const checkoutError = useCheckoutError()

  return checkoutError?.extra?.facilityApplicationIntroductionEligibility === 'eligible'
}
